import type { ISecurityGroup } from '@/interfaces'

export class SecurityGroup implements ISecurityGroup {
	displayName: string
	groupTypes: string[]
	id: string
	membershipRule: string
	securityIdentifier: string
	constructor({ displayName, groupTypes, id, membershipRule, securityIdentifier }: Partial<ISecurityGroup> = {}) {
		this.displayName = displayName || ''
		this.groupTypes = groupTypes || []
		this.id = id || ''
		this.membershipRule = membershipRule || ''
		this.securityIdentifier = securityIdentifier || ''
	}
}
